// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uJ-z","hovered":"vJ-z","hoverImage":"wJ-z","mainImage":"xJ-z","imageNoBackground":"yJ-z","fullSizeImage":"zJ-z"};